import {
  Anchor,
  Box,
  Button,
  Container,
  Grid,
  Group,
  Image,
  List,
  Stack,
  Text,
  Title,
} from "@mantine/core";
import { IconCheck, IconDownload } from "@tabler/icons-react";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import {
  imgDinLabelLaptop,
  imgEtiquetaConMarcaDeAgua,
  imgEtiquetaSinMarcaDeAgua,
} from "../shared/images";
import { NavBarContainer } from "./NavBarContainer";

const DOWNLOAD_URL =
  "https://labelmaster.azurewebsites.net/labelmaster/setup.exe";

const panelStyle: React.CSSProperties = {
  background: "white",
  border: "1px solid var(--mantine-color-gray-2)",
  borderRadius: "var(--mantine-radius-md)",
  boxShadow: "0 8px 32px rgba(44, 45, 48, 0.06)",
  height: "100%",
};

export function InstallPage() {
  const { t } = useTranslation();

  return (
    <NavBarContainer fullBleed showFooter>
      <Box
        style={{
          background:
            "linear-gradient(160deg, #fff8f2 0%, #ffffff 45%, #fff4eb 100%)",
          minHeight: "calc(100vh - 60px - 160px)",
        }}
        py={{ base: "xl", md: 48 }}
      >
        <Container size="lg">
          <Stack gap={48}>
            {/* Hero */}
            <Grid align="center">
              <Grid.Col span={{ base: 12, md: 7 }}>
                <Stack gap="lg">
                  <div>
                    <Title order={1} c="charcoal.8" mb="xs">
                      {t("install.title")}
                    </Title>
                    <Text c="dimmed" size="lg" maw={480}>
                      {t("install.intro")}
                    </Text>
                  </div>
                  <Group gap="md">
                    <Button
                      component="a"
                      href={DOWNLOAD_URL}
                      size="lg"
                      color="brand"
                      leftSection={<IconDownload size={20} />}
                    >
                      {t("nav.download")}
                    </Button>
                    <Button
                      component={Link}
                      to="/buy"
                      size="lg"
                      variant="outline"
                      color="charcoal"
                    >
                      {t("install.buyApp")}
                    </Button>
                  </Group>
                  <Text size="sm" c="dimmed">
                    {t("install.windowsNote")}
                  </Text>
                </Stack>
              </Grid.Col>
              <Grid.Col span={{ base: 12, md: 5 }}>
                <Image
                  src={imgDinLabelLaptop}
                  alt="DinLabel"
                  maw={360}
                  mx="auto"
                  style={{
                    filter: "drop-shadow(0 20px 40px rgba(44, 45, 48, 0.16))",
                  }}
                />
              </Grid.Col>
            </Grid>

            {/* Free vs full */}
            <Grid>
              <Grid.Col span={{ base: 12, md: 6 }}>
                <Stack gap="md" p="xl" style={panelStyle} align="center">
                  <Image
                    src={imgEtiquetaConMarcaDeAgua}
                    alt=""
                    maw={200}
                    radius="sm"
                  />
                  <Title order={3} c="charcoal.8" ta="center">
                    {t("install.freeTag")}
                  </Title>
                  <Text ta="center" size="sm" c="dimmed" maw={320}>
                    {t("install.freeText")}
                  </Text>
                  <Button
                    component="a"
                    href={DOWNLOAD_URL}
                    color="brand"
                    fullWidth
                    maw={280}
                    leftSection={<IconDownload size={18} />}
                  >
                    {t("nav.download")}
                  </Button>
                </Stack>
              </Grid.Col>
              <Grid.Col span={{ base: 12, md: 6 }}>
                <Stack
                  gap="md"
                  p="xl"
                  align="center"
                  style={{
                    ...panelStyle,
                    borderColor: "var(--mantine-color-brand-3)",
                    boxShadow: "0 8px 32px rgba(242, 122, 33, 0.12)",
                  }}
                >
                  <Image
                    src={imgEtiquetaSinMarcaDeAgua}
                    alt=""
                    maw={200}
                    radius="sm"
                  />
                  <Title order={3} c="charcoal.8" ta="center">
                    {t("install.paidTitle")}
                  </Title>
                  <Text ta="center" size="sm" c="dimmed" maw={320}>
                    {t("install.paidText")}
                  </Text>
                  <Button
                    component={Link}
                    to="/buy"
                    color="brand"
                    fullWidth
                    maw={280}
                  >
                    {t("install.buyApp")}
                  </Button>
                </Stack>
              </Grid.Col>
            </Grid>

            {/* Requirements */}
            <Box p="xl" style={panelStyle}>
              <Title order={3} c="charcoal.8" mb="md">
                {t("install.requirements")}
              </Title>
              <List
                spacing="sm"
                icon={
                  <IconCheck
                    size={16}
                    color="var(--mantine-color-brand-6)"
                  />
                }
              >
                <List.Item>
                  <Text c="charcoal.7">{t("install.reqWindows")}</Text>
                </List.Item>
                <List.Item>
                  <Text c="charcoal.7">{t("install.reqInternet")}</Text>
                </List.Item>
                <List.Item>
                  <Text c="charcoal.7">{t("install.reqRam")}</Text>
                </List.Item>
                <List.Item>
                  <Text c="charcoal.7">{t("install.reqDisk")}</Text>
                </List.Item>
              </List>
            </Box>

            <Text ta="center" size="sm" c="dimmed">
              {t("install.orDistributor")}{" "}
              <Anchor
                component={Link}
                to="/viewdistributors"
                c="brand.7"
                fw={600}
              >
                {t("install.distributorsLink")}
              </Anchor>
            </Text>
          </Stack>
        </Container>
      </Box>
    </NavBarContainer>
  );
}
